import { BrowserModule }  from '@angular/platform-browser';
import { FormsModule }    from '@angular/forms';
import { NgModule }       from '@angular/core';
import { HttpModule }     from '@angular/http';
import { LOCALE_ID }      from '@angular/core';

import {NgbModule}        from '@ng-bootstrap/ng-bootstrap'

import { AppRoutingModule } from './app.routing.module';
import { AppComponent }     from './app.component';

import * as providers from '../providers/providers';
import * as pages from '../pages/pages';
import * as pipes from '../pipes/pipes';

@NgModule({
  declarations: [
    AppComponent,

    pages.LoginPage,
    pages.HomePage,
    pages.AddStamplingModal,
    pages.AccountPage,

    pipes.TimePipe,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    FormsModule,
    HttpModule,

    NgbModule.forRoot()
  ],
  providers: [
    providers.Holidays,
    providers.Guard,
    providers.StamplingDB,
    { provide: LOCALE_ID, useValue: "it-IT" }
  ],
  entryComponents: [
    pages.AddStamplingModal,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/app/app.module.ts